import React, {useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from 'react-router-dom';
import { UpdateUserHeaderSettings } from '../../../actions/UserSettingActions';
import ExcelDownload from './ExcelDownload';
import FieldSelect from './FieldSelect';
import useScreenSize from '../../../components/useScreenSize';
import updateUserFieldSettings from '../../../state/userSettingsSlice';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional Theme applied to the Data Grid
import {
  BulkActionApprove,
  BulkActionApproveAll,
  BulkActionReject,
  BulkActionRejectAll,
  BulkActionDelete,
  BulkActionDeleteAll,
  BulkActionUnassign,
  BulkActionUnassignAll,
  BulkActionSendToImageReview,
  BulkActionSendToImageReviewAll,
  BulkActionChangeToReadyStatus,
  BulkActionChangeToReadyStatusAll,
  BulkActionMoveAndAssign,
  BulkActionMoveAndAssignAll,
  GetWorkflowStepsByBpId,
  BulkActionsDownload,
} from '../../../actions/BulkActions';
import ActiveDocumentStore from '../../../stores/ActiveDocumentStore';
import SearchStore from '../../../stores/SearchStore';
import DocumentStore from '../../../stores/DocumentStore';
import BulkActionStore from '../../../stores/BulkActionStore';
import actionTypes from '../../../actions/ActionTypes';
import {
  FetchAssignableUsers,
  GetAvailableBps,
  GetAvailableTemplatesByBp2,
  ChangeBusinessProcesses,
} from '../../../actions/DocumentActions';
import AutoComplete from '../../../components/AutoComplete';
import BulkRejectDlg from './BulkRejectDlg';
import BulkDownloadDlg from './BulkDownloadDlg';
import TemplateChangeDlg from './TemplateChangeDlg';



const DocumentList2 = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const gridRef = useRef(null);
    const colUpdate = useRef(null);
    const [allCheck, setAllCheck] = useState(false);
    const userInfo = useSelector(state => state.userInfo.value);
    //const screenSize = useSelector(state => state.screenSizeInfo.value);
    const [viewHeight, viewWidth] = useScreenSize();
    const userSettings = useSelector(state => state.userSettingInfo.value);
    const [downloadConfirmation, setDownloadConfirmation] = useState(false);
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [showBulkMenu, setShowBulkMenu] = useState(false);
    const [showFieldSelect, setShowFieldSelect] = useState(false);
    const [showExcelExport, setShowExcelExport] = useState(false);
    const [showBulkApprove, setShowBulkApprove] = useState(false);
    const [showBulkReject, setShowBulkReject] = useState(false);
    const [selectedDocCount, setSelectedDocCount] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showBulkDelete, setShowBulkDelete] = useState(false);
    const [showBulkUnassign, setShowBulkUnassign] = useState(false);
    const [showBulkSendToImageReview, setShowBulkSendToImageReview] = useState(false);
    const [showBulkChangeToReadyStatus, setShowBulkChangeToReadyStatus] = useState(false);
    const [showBulkMoveAndAssign, setShowBulkMoveAndAssign] = useState(false);
    const [showBulkChangeBusinessProcess, setShowBulkChangeBusinessProcess] = useState(false);
    const [showTemplateChange, setShowTemplateChange] = useState(false);
    const [showBulkDownload, setShowBulkDownload] = useState(false);
    const [bulkWorkflowStepArray, setBulkWorkflowStepArray] = useState([]);
    const [moveAssignStepId, setMoveAssignStepId] = useState(-1);
    const [moveAssignUserSearch, setMoveAssignUserSearch] = useState('');
    const [moveAssignUsers, setMoveAssignUsers] = useState([]);
    const [moveAssignSelectedUsers, setMoveAssignSelectedUsers] = useState([]);
    const [moveAssignFilteredUsers, setMoveAssignFilteredUsers] = useState([]);
    const [availableBps, setAvailableBps] = useState([]);
    const [availableTemplates2, setAvailableTemplates2] = useState([]);
    const [selectedBpId2, setSelectedBpId2] = useState(-1);
    const [selectedTemplate2, setSelectedTemplate2] = useState(-1);
    //const [h, setH] = useState(window.innerHeight - 150);

    const idColCompare = (valueA, valueB, nodeA, nodeB, isDescending) => {

      return valueA.Id - valueB.Id
    };

    useEffect(() => {
      let myColDefs = [...props.colDefs];
      let idCol = myColDefs.find(d => d.field === 'Id');
      let idx = myColDefs.indexOf(idCol);
      let newIdCol = {...idCol};
      //newIdCol.lockPosition = 'left';
      newIdCol.pinned = 'left';
      newIdCol.cellRenderer = RowIdCell;
      myColDefs[idx] = newIdCol;
      newIdCol.comparator = idColCompare;
      setColDefs(myColDefs);
    }, [props.colDefs, props.fieldSettings])

    // useEffect(() => {
    //   setH(screenSize.sideBarHeight - 0);
    //   console.log(screenSize.sideBarHeight);
    // }, [screenSize]);

    useEffect(() => {
      const onBulkChange = () => {
        let lastChange = BulkActionStore.getLastChange();
        if (lastChange === actionTypes.BulkAction) {
          setShowBulkMenu(false);
          props.onRefresh();
          return;
        }
        if (lastChange === actionTypes.WorkflowStepAction) {
          let result = BulkActionStore.getWorkflowStepsResults();
          let temp = result.responseDocuments.map(doc => ({
            stepId: doc.stepId,
            stepName: doc.stepName,
          }));
          setBulkWorkflowStepArray(temp);
        }
        if (lastChange === actionTypes.DocumentGetAvailTemplatesByBp2) {
          let templates = BulkActionStore.getWorkflowAvailableTemplatesResults();
          setAvailableTemplates2(templates);
        }
        if (lastChange === actionTypes.DocumentGetAvailBpByBp) {
          let bps = BulkActionStore.getBulkBpResults();
          setAvailableBps(bps);
        }
      };
      BulkActionStore.addChangeListener(onBulkChange);
      return () => BulkActionStore.removeChangeListener(onBulkChange);
    }, []);

    useEffect(() => {
      const onDocChange = () => {
        let lastChange = DocumentStore.lastChange();
        if (lastChange === actionTypes.DocumentAssignUsers) {
          let assUsers = DocumentStore.getMoveAssignUsers();
          let users = assUsers.assignableUsers || [];
          setMoveAssignUsers(users);
          setMoveAssignFilteredUsers(users);
        }
      };
      DocumentStore.addChangeListener(onDocChange);
      return () => DocumentStore.removeChangeListener(onDocChange);
    }, []);

    const rowSelection = useMemo(() => {
      return {
            mode: 'multiRow',
            enableClickSelection: false,
            headerCheckbox: false,
            checkboxes: false,
            selectAll: 'filtered',
        };
    }, []);

    const selectionColumnDef = useMemo(() => {
      return {
            width: 80,
            suppressHeaderMenuButton: false,
            suppressMovable: 'true',

        };
    }, []);


    const rowClick = (p, ev) => {
      console.log(p.data);

      if(ev.ctrlKey === true)
      {
        window.open(`/Document/${p.value.Id}`, '_blank');
      } else {
        navigate(`/Document/${p.data.Id.Id}`, {replace: false});
      }
    };

    const bulkActionClick = () => {

      console.log('bulk action clicking');
      if (showBulkMenu){
        removeCheckboxColumn();
      }
      else{
        addCheckboxColumn();
      }

      setShowBulkMenu(!showBulkMenu);
    };

    const RowIdCell = p => {
      return <>
      <div className='row flex-nowrap' onClick={(e) => rowClick(p, e)} style={{paddingLeft: '-1px', cursor: 'pointer'}}>

        {p.value.status === 0 &&
        <>
        <div className='col-auto col-ready m-0'>
          <i className='fa-solid fa-check' />
        </div>
        <div className='col-auto trans' style={{paddingLeft: '0px'}}>
        <svg width='8' height='36'>
          <polygon
            points='0,0 8,16, 0,32'
            fill='#3FAD42'
          />
        </svg>
        </div>
        </>
        }
        {p.value.status === 2 &&
        <>
        <div className='col-auto col-error m-0'>
          <i className='fa-regular fa-triangle-exclamation' />
        </div>
        <div className='col-auto trans' style={{paddingLeft: '0px'}}>
        <svg width='8' height='36'>
          <polygon
            points='0,0 8,16, 0,32'
            fill='#e73827'
          />
        </svg>
        </div>
        </>
        }
        {p.value.status === 1 &&
        <>
        <div className='col-auto col-lock m-0'>
          <i className='fa-solid fa-user-pen' /> {p.value.user}
        </div>
        <div className='col-auto trans' style={{paddingLeft: '0px'}}>
        <svg width='8' height='36'>
          <polygon
            points='0,0 8,16, 0,32'
            fill='#ddc562'
          />
        </svg>
        </div>
        </>
        }

        {p.value.Id}
      </div>
      </>;

    }

    const updateColumnSettings = (api) => {
      let settings = [];
        let defs = api.getColumnDefs();
        //console.log(defs);

        let i = 0;
        let hasChange = false;
        defs.forEach((def) => {

          // Skip the bulk-action checkbox column — it is not in fieldSettings
          // and would shift every subsequent index, corrupting saved names.
          if (def.field === '_checkbox') return;

          if(userSettings.fieldSettings.formTypeId === props.formTypeId)
          {
            let col = userSettings.fieldSettings.columns[i];

            if(col.colName !== def.field && col.displayName !== def.headerName) hasChange = true;
            if(col.show === true && (def.hide === true)) hasChange = true;
            if(col.show === false && (def.hide === false || def.hide === undefined)) hasChange = true;
            if(col.colWidth !== def.width) hasChange = true;

            let colInfo = {};
            // Use def.field (the original field name) rather than def.colId so
            // that AG Grid's deduplication suffix (_1, _1_1, …) is never
            // persisted back to the database.
            colInfo.colName = def.field || def.colId;
            colInfo.colWidth = def.width;
            colInfo.display = true;
            colInfo.sortDir = null;
            if(def.hide) colInfo.display = false;
            let col2 = userSettings.fieldSettings.columns.find(p => p.colName === def.field || p.colName === def.headerName);
            if(col2)
            {
              colInfo.fieldId = col2.fieldId;
            }
            settings.push(colInfo);
          }
          i++;

        });
        //console.log(settings);
        if(hasChange) {
          UpdateUserHeaderSettings(props.formTypeId, settings, dispatch);
        }
        //
    }

    const colWidthChange = (e) => {
      window.clearTimeout(colUpdate.current);
      colUpdate.current = window.setTimeout(() => updateColumnSettings(e.api), 1000);
    }

    const toggleFieldDisplay = (col) => {
      let sourceCols = [...props.colDefs];
      let curColDefs = [...colDefs];
      let fieldSetting = [...props.fieldSettings.columns];
        // remove a column.
        let colToRemove = curColDefs.find(f => f.field === col.colName || f.headerName === col.colName);
        if(colToRemove) {
          let idx = curColDefs.indexOf(colToRemove);
          colToRemove.hide = !col.show;
          curColDefs[idx] = colToRemove;
          setColDefs(curColDefs);
        }

    }


    const checkboxColumn = {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      pinned: 'left',
      lockedPosition: 'left',
      suppressMenu: true,
      lockPinned: true,
      field: '_checkbox',
      headerName: '',
      resizable: false,
      suppressSizeToFit: true,
      width: 50,
      maxWidth: 50,
      minWidth: 50,
    };

    const addCheckboxColumn =() => {
      setColDefs((prev) => {
        // avoid adding it twice
        if (prev.find((col) => col.field === '_checkbox')) return prev;
        return [checkboxColumn, ...prev];
      });
    };

    const onFilterChanged = () => {
      const model = gridRef.current.api.getFilterModel();
      const hasFilters = Object.keys(model).length > 0;
      setIsFilterActive(hasFilters);

      if (hasFilters) {
        const filteredIds = [];
        const visibleNodes = new Set();
        gridRef.current.api.forEachNodeAfterFilter(node => {
          visibleNodes.add(node);
          if (node.data?.Id?.Id !== undefined) {
            filteredIds.push(node.data.Id.Id);
          }
        });
        SearchStore.setDocList(filteredIds);

        // restrict any existing selection to the rows that passed the filter,
        // so rows hidden by the filter can't be part of a bulk action
        const hiddenSelected = [];
        gridRef.current.api.forEachNode(node => {
          if (node.isSelected() && !visibleNodes.has(node)) {
            hiddenSelected.push(node);
          }
        });
        if (hiddenSelected.length > 0) {
          gridRef.current.api.setNodesSelected({ nodes: hiddenSelected, newValue: false });
        }
      } else {
        const allIds = props.rowData.map(r => r.Id?.Id).filter(id => id !== undefined);
        SearchStore.setDocList(allIds);
      }

      // the grid does not fire selectionChanged when a filter changes,
      // so re-evaluate the select-all/fullStep state against the new view
      if (showBulkMenu) {
        onSelectionChange();
      }
    };

    const clearFilter = () => {
      gridRef.current.api.setFilterModel(null);
      setIsFilterActive(false);
    };

    // Remove the checkbox column if present
    const removeCheckboxColumn = () => {
      setColDefs((prev) => prev.filter((col) => col.field !== '_checkbox'));
    };


    const [colDefs, setColDefs] = useState([
      { field: "Id",  lockPosition: 'left', pinned: 'left', cellRenderer: RowIdCell },
      { field: "Step" },
      { field: "Pages" },
      { field: "Queues" },
      { field: "Notes" },
      { field: "Related" },
    ]);


    const getFullSearchParams = () => {
      let p = props.getSearch();
      p.fullStep = true;

      let sortModel = gridRef.current.api.getColumnState();
      let sort = { id: "Id", sortDir: "asc" };
      if(sortModel.length > 0) {
        sortModel.forEach(sm => {
          if(sm.sort != null) {
            sort = { id: sm.colId, sortDir: sm.sort }
          }
        })
      }
      p.sortModel = sort;

      let filters = gridRef.current.api.getFilterModel();
      console.log(filters);

      console.log(Object.keys(filters));
      if(Object.keys(filters).length > 0)
      {
        let filterList = [];
        for(var key in filters) {
          let filterObj = filters[key];
          let filter = { fieldId: key, filterType: filterObj.filterType };
          if(filterObj.conditions !== undefined) {
            console.log('multi-condition');
            console.log(filterObj);
            filter.filterOperator = filterObj.operator;
            filter.conditions = [];
            filterObj.conditions.forEach(cond => {
              let filterparam = v.filterObj === undefined ? null : cond.filterObj.toString();
              filter.conditions.push({ filterValue: filterparam, filterType: cond.type })
            });
          } else {
            console.log('single-condition');
            console.log(filterObj);
            filter.conditions = [];
            filter.filterOperator = "";
            console.log(filterObj);
            let filterparam = filter.filterObj === undefined ? null : filter.filterObj.toString();
            filter.conditions.push({ filterValue: filterparam, filterType: filterObj.type });

          }
          filterList.push(filter);
          console.log(key);
          console.log();
        }
        console.log(filterList);
        p.filterModels = filterList;
      }

      return p;
    }
    const getSearchParams = () => {
      let p = props.getSearch();
      p.fullStep = allCheck;

      let params = new URLSearchParams(window.location.search);
      let stepParam = params.get('Step');
      let bpParam = params.get('BP');
      p.stepId = parseInt(stepParam, 10);
      p.bpId = parseInt(bpParam, 10);
      if (!p.fullStep) {
        let rows = gridRef.current.api.getSelectedRows();
        p.docs = rows.map(r => r.Id.Id);
      } else {
        p.docs = [];
      }
      return p;
    }

    const toggleShowExcel = () => {
      let filters = gridRef.current.api.getFilterModel();
      let state = gridRef.current.api.getState();

      console.log(state);
      setShowExcelExport(!showExcelExport);
    }

    const onSelectionChange = () => {
      const allRows = gridRef.current.api.getDisplayedRowCount();
      const selectedRows = gridRef.current.api.getSelectedRows().length;
      const hasFilters = Object.keys(gridRef.current.api.getFilterModel()).length > 0;
      setSelectedDocCount(selectedRows);
      setSelectedRows(gridRef.current.api.getSelectedRows());
      // fullStep only applies when every document is selected with no filter active;
      // a filtered select-all must stay an explicit list of ids
      if(selectedRows === allRows && !hasFilters) {
        setAllCheck(true);
      } else {
        setAllCheck(false);
      }
    }


    const bulkApproveClick = () => {
      var selectedDocs = { docIds: [] };
      selectedRows.map((doc) =>
        selectedDocs.docIds.push({
          documentId: doc.Id.Id,
          stepId: props.stepId,
        })
      );
      BulkActionApprove(selectedDocs);
      setShowBulkApprove(false);
    }

    const bulkDeleteClick = () => {
      var selectedDocs = { docIds: [] };
      selectedRows.map((doc) =>
        selectedDocs.docIds.push({
          documentId: doc.Id.Id,
          stepId: props.stepId,
        })
      );
      BulkActionDelete(selectedDocs);
      setShowBulkDelete(false);
    }

    const bulkUnassignClick = () => {
      var selectedDocs = { docIds: [] };
      selectedRows.map((doc) =>
        selectedDocs.docIds.push({
          documentId: doc.Id.Id,
          stepId: props.stepId,
        })
      );
      BulkActionUnassign(selectedDocs);
      setShowBulkUnassign(false);
    }

    const bulkSendToImageReviewClick = () => {
      var selectedDocs = { docIds: [] };
      selectedRows.map((doc) =>
        selectedDocs.docIds.push({
          documentId: doc.Id.Id,
          stepId: props.stepId,
        })
      );
      BulkActionSendToImageReview(selectedDocs);
      setShowBulkSendToImageReview(false);
    }

    const bulkChangeToReadyStatusClick = () => {
      var selectedDocs = { docIds: [] };
      selectedRows.map((doc) =>
        selectedDocs.docIds.push({
          documentId: doc.Id.Id,
          stepId: props.stepId,
        })
      );
      BulkActionChangeToReadyStatus(selectedDocs);
      setShowBulkChangeToReadyStatus(false);
    }

    const openMoveAndAssign = () => {
      let params = new URLSearchParams(window.location.search);
      let bpParam = params.get('BP');
      GetWorkflowStepsByBpId(bpParam);
      setMoveAssignStepId(-1);
      setMoveAssignSelectedUsers([]);
      setMoveAssignUserSearch('');
      setShowBulkMoveAndAssign(true);
    }

    const editMoveAssignStep = (e) => {
      let stepId = parseInt(e.target.value, 10);
      setMoveAssignStepId(stepId);
      let params = new URLSearchParams(window.location.search);
      let bpParam = params.get('BP');
      FetchAssignableUsers(stepId, parseInt(bpParam, 10));
    }

    const onMoveAssignUserSearch = (e) => {
      let val = e.target.value;
      setMoveAssignUserSearch(val);
      let filtered = moveAssignUsers.filter(u =>
        u.userName.substring(0, val.length).toUpperCase() === val.toUpperCase() ||
        u.fullName.substring(0, val.length).toUpperCase() === val.toUpperCase()
      );
      setMoveAssignFilteredUsers(filtered);
    }

    const onClickMoveAssignableUser = (user) => {
      if (!moveAssignSelectedUsers.find(u => u.userId === user.userId)) {
        setMoveAssignSelectedUsers(prev => [...prev, user]);
      }
      setMoveAssignUserSearch('');
      setMoveAssignFilteredUsers([]);
    }

    const onClickRemoveMoveAssignUser = (user) => {
      setMoveAssignSelectedUsers(prev => prev.filter(u => u.userId !== user.userId));
    }

    const moveAssignDocClick = () => {
      let selectedDocs = {
        docIds: [],
        stepId: moveAssignStepId,
        assignToUserIds: moveAssignSelectedUsers.map(u => u.userId),
      };
      selectedRows.map((doc) =>
        selectedDocs.docIds.push({
          documentId: doc.Id.Id,
          stepId: props.stepId,
        })
      );
      BulkActionMoveAndAssign(selectedDocs);
      setShowBulkMoveAndAssign(false);
    }

    const openChangeBP = () => {
      let params = new URLSearchParams(window.location.search);
      let bpParam = params.get('BP');
      GetAvailableBps(bpParam);
      setSelectedBpId2(-1);
      setSelectedTemplate2(-1);
      setAvailableTemplates2([]);
      setShowBulkChangeBusinessProcess(true);
    }

    const editBps = (e) => {
      let val = parseInt(e.target.value, 10);
      setSelectedBpId2(val);
      GetAvailableTemplatesByBp2(val);
    }

    const moveBpDocsClick = () => {
      var docIds = [];
      selectedRows.map((doc) => docIds.push(doc.Id.Id));
      ChangeBusinessProcesses(docIds, selectedTemplate2, true, selectedBpId2);
      setShowBulkChangeBusinessProcess(false);
    }

    const getBulkDocs = () => {
      let bulkParams = { docIds: [], fullStep: allCheck };
      let rows = gridRef.current.api.getSelectedRows();
      rows.forEach((row) => bulkParams.docIds.push(row.Id.Id));
      return bulkParams;
    }



    return (
        <div
            className='d-flex flex-column flex-fill'
            style={{
            width: `${viewWidth-320}px`,
            height: `${viewHeight- 57}px`,
            position: 'relative'

            }}
        >
            <div
            className='d-flex '
            style={{
                background: '#EFEFEF',
                borderBottom: 'solid 1px #BBB',
                width: `${viewWidth -320}px`,
            }}
            >
                <div className='p-2 me-2'>
                    <strong>BP</strong>: {props.bpName}
                </div>
                {props.stepName !== undefined &&
                  <div className='p-2 me-2'>
                      <strong>Step</strong>: {props.stepName}
                  </div>
                }

                <div className='p-2 me-auto'>
                    <strong>Count</strong>: {props.docCount}
                </div>
                { showBulkMenu &&
                <div className='p-2 me-2'>
                    <strong>Checked Count</strong>:{' '}{selectedDocCount}
                </div>
                }

                <div
                    className='p-2 me-3'
                    style={{ cursor: props.refreshing ? 'default' : 'pointer' }}
                    onClick={!props.refreshing ? props.onRefresh : undefined}
                >
                    {props.refreshing
                      ? <><i className='fas fa-spinner fa-pulse' /> Refresh</>
                      : <><i className='fa-solid fa-redo' /> Refresh</>
                    }
                </div>
                <div
                    className='p-2 me-3'
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleShowExcel()}
                >
                    <i className='fa-regular fa-file-xls' /> Excel
                </div>
                <div  className='dropdown float-start' >
                <div
                  onClick={() => bulkActionClick()}
                  className='p-2 me-3'
                  style={{ cursor: 'pointer' }}
                >
                  <i className='fa-solid fa-list-ul' /> Bulk Actions


                    {showBulkMenu &&
                  <div id='bulkMenuDropdown' className='dropdown-content-bulk-menu bulk-menu-hide' >

                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkApprove(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-thumbs-up'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Approve
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkReject(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-thumbs-down'
                          style={{ color: '#DF3E3E', marginRight: '8px' }}
                        />
                        Reject
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          openChangeBP();
                        }}
                      >
                        <i
                          className='fa-solid fa-code-branch'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Change Business Process
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTemplateChange(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-columns'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Change Readers
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkChangeToReadyStatus(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-check-circle'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Change to Ready Status
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkDelete(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-remove'
                          style={{ color: '#EC4B4B', marginRight: '8px' }}
                        />
                        Delete
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          openMoveAndAssign();
                        }}
                      >
                        <i
                          className='fa-solid fa-exchange'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Move & Assign
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkSendToImageReview(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-file-pdf'
                          style={{ color: '#AE4BCF', marginRight: '8px' }}
                        />
                        Send To Image Review
                      </div>

                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkUnassign(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-backspace'
                          style={{ color: '#38C158', marginRight: '8px' }}
                        />
                        Unassign
                      </div>


                      <div
                        className='dropdown-menuitem'
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowBulkDownload(true);
                        }}
                      >
                        <i
                          className='fa-solid fa-download'
                          style={{ color: '#D20707', marginRight: '8px' }}
                        />
                        Download
                      </div>

                    <div
                      className='dropdown-menuitem'
                      onClick={() => setShowBulkMenu(false)}
                    >
                      <i
                        className='fa-solid fa-external-link-alt'
                        style={{ color: '#38C158', marginRight: '8px' }}
                      />
                      Exit Bulk Actions
                    </div>
                  </div>
                    }

                </div>
                </div>
                <div
                    className='p-2 me-3'
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowFieldSelect(true)}
                >
                    <i className='fa-regular fa-table-columns' /> Fields
                </div>
                {isFilterActive && (
                  <div
                    className='p-2 me-3'
                    style={{ cursor: 'pointer' }}
                    title='Clear all Filters'
                    onClick={clearFilter}
                  >
                    <i className='fa-solid fa-filter-slash' /> Clear all Filters
                  </div>
                )}
            </div>
            <div
         className="ag-theme-alpine" // applying the Data Grid theme
         style={{ height: viewHeight }} // the Data Grid will fill the size of the parent container
        >
            <AgGridReact
                rowHeight={36}
                ref={gridRef}
                rowData={props.rowData}
                columnDefs={colDefs}
                defaultColDef={{ filterParams: { buttons: ['reset'] } }}
                pagination={false}
                rowSelection={showBulkMenu ? rowSelection : null}
                selectionColumnDef={selectionColumnDef}
                onColumnResized = {(e) => colWidthChange(e)}
                onColumnMoved = {(e) => colWidthChange(e)}
                onDisplayedColumnsChanged = {(e) => colWidthChange(e)}
                onSelectionChanged = {onSelectionChange}
                onFilterChanged = {onFilterChanged}
            />
            </div>
            {showExcelExport &&
              <ExcelDownload
                close={() => toggleShowExcel()}
                getSearch={getFullSearchParams}
                mode={props.mode}
                formTypeId={props.formTypeId}
              ></ExcelDownload>
            }
            {showFieldSelect &&
              <FieldSelect
                close={()=> setShowFieldSelect(false)}
                columnSettings={props.fieldSettings}
                toggleFieldDisplay={toggleFieldDisplay}
                formTypeId={props.formTypeId}
              ></FieldSelect>
            }

            {showBulkApprove && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '300px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Approve
                    <button
                      onClick={() => setShowBulkApprove(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be approved
                      </label>
                    </div>
                    <button
                      onClick={() => bulkApproveClick()}
                      className='btn btn-success mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showBulkReject && (
              <BulkRejectDlg
                close={(done) => { setShowBulkReject(false); if (done === 'done') { setShowBulkMenu(false); props.onRefresh(); } }}
                docs={getBulkDocs}
                getSearch={getSearchParams}
              />
            )}

            {showBulkDelete && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '300px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Delete
                    <button
                      onClick={() => setShowBulkDelete(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be deleted
                      </label>
                    </div>
                    <button
                      onClick={() => bulkDeleteClick()}
                      className='btn btn-danger mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showBulkUnassign && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '300px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Unassign
                    <button
                      onClick={() => setShowBulkUnassign(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be unassigned
                      </label>
                    </div>
                    <button
                      onClick={() => bulkUnassignClick()}
                      className='btn btn-success mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showBulkSendToImageReview && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '300px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Send to Image Review
                    <button
                      onClick={() => setShowBulkSendToImageReview(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be sent to Image Review
                      </label>
                    </div>
                    <button
                      onClick={() => bulkSendToImageReviewClick()}
                      className='btn btn-success mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showBulkChangeToReadyStatus && (
              <div className='td-dialogue-container'>
                <div
                  className='td-dialogue card'
                  style={{ height: '300px', width: '600px' }}
                >
                  <div className='card-header'>
                    Bulk Change to Ready Status
                    <button
                      onClick={() => setShowBulkChangeToReadyStatus(false)}
                      className='btn-close'
                    />
                  </div>
                  <div className='card-body'>
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be set to Ready
                      </label>
                    </div>
                    <button
                      onClick={() => bulkChangeToReadyStatusClick()}
                      className='btn btn-success mt-3 w-100'
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showBulkMoveAndAssign && (
              <div className='td-dialogue-container'>
                <div className='td-dialogue card' style={{ width: '720px' }}>
                  <div className='card-header'>
                    Move and Assign
                    <button
                      type='button'
                      className='btn-close'
                      onClick={() => setShowBulkMoveAndAssign(false)}
                    />
                  </div>
                  <div
                    className='card-body'
                    style={{ height: '500px', padding: '40px', overflow: 'auto' }}
                  >
                    <label className='form-label'>Workflow Step</label>
                    <select
                      className='form-select'
                      value={moveAssignStepId}
                      onChange={editMoveAssignStep}
                    >
                      <option value='-1'></option>
                      {bulkWorkflowStepArray.map((dest) => (
                        <option key={dest.stepId} value={dest.stepId}>
                          {dest.stepName}
                        </option>
                      ))}
                    </select>
                    <label className='form-label mt-4'>Assign User(s)</label>
                    <div className='d-flex flex-row flex-wrap'>
                      {moveAssignSelectedUsers.map((user) => (
                        <div key={user.userId} className='queueAssignOther mt-2 me-2'>
                          {user.userName}{' '}
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => onClickRemoveMoveAssignUser(user)}
                            className='fa-solid fa-times'
                          />
                        </div>
                      ))}
                    </div>
                    <input
                      type='text'
                      className='form-control mt-2'
                      placeholder='Search user...'
                      value={moveAssignUserSearch}
                      onChange={onMoveAssignUserSearch}
                    />
                    {moveAssignUserSearch.length > 0 && moveAssignFilteredUsers.length > 0 && (
                      <div style={{ border: '1px solid #ccc', maxHeight: '200px', overflowY: 'auto' }}>
                        {moveAssignFilteredUsers.map((user) => (
                          <div
                            key={user.userId}
                            className='docAssignItem'
                            style={{ cursor: 'pointer', padding: '6px 10px' }}
                            onMouseDown={() => onClickMoveAssignableUser(user)}
                          >
                            <div><strong>{user.fullName}</strong></div>
                            <div className='docAssignSubHeader'>{user.userName}</div>
                          </div>
                        ))}
                      </div>
                    )}
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be moved.
                      </label>
                    </div>
                    {moveAssignStepId !== -1 && (
                      <button
                        className='btn btn-success mt-3'
                        onClick={moveAssignDocClick}
                      >
                        <i className='fa-solid fa-check' /> OK
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {showBulkChangeBusinessProcess && (
              <div className='td-dialogue-container'>
                <div className='td-dialogue card' style={{ width: '720px' }}>
                  <div className='card-header'>
                    Change Business Process
                    <button
                      type='button'
                      className='btn-close'
                      onClick={() => setShowBulkChangeBusinessProcess(false)}
                    />
                  </div>
                  <div
                    className='card-body'
                    style={{ height: '500px', padding: '40px', overflow: 'auto' }}
                  >
                    <label className='form-label'>Business Process</label>
                    <select
                      className='form-select'
                      value={selectedBpId2}
                      onChange={editBps}
                    >
                      <option value='-1'></option>
                      {availableBps.map((bp) => (
                        <option key={bp.bpId} value={bp.bpId}>
                          {bp.bpName}
                        </option>
                      ))}
                    </select>
                    <label className='form-label mt-3'>Choose Template</label>
                    <AutoComplete
                      id='cbp_chooseTemplate'
                      allowedValues={availableTemplates2}
                      value={selectedTemplate2}
                      valueField='templateId'
                      displayField='templateName'
                      onChange={(val) => setSelectedTemplate2(val)}
                    />
                    <div className='form-check mt-2'>
                      <label className='form-check-label'>
                        {selectedDocCount} document(s) will be moved.
                      </label>
                    </div>
                    {selectedBpId2 !== -1 && (
                      <button
                        className='btn btn-success mt-3'
                        onClick={moveBpDocsClick}
                      >
                        <i className='fa-solid fa-check' /> OK
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}

            {showTemplateChange && (
              <TemplateChangeDlg
                close={(done) => { setShowTemplateChange(false); if (done === 'done') { setShowBulkMenu(false); props.onRefresh(); } }}
                docs={getBulkDocs}
                getSearch={getSearchParams}
              />
            )}

            {showBulkDownload && (
              <BulkDownloadDlg
                close={() => setShowBulkDownload(false)}
                docs={getBulkDocs}
                getSearch={getSearchParams}
              />
            )}

        </div>
    );
}

export default DocumentList2;
